(()=>{
  if(window.__kidatagGlobalFix3108) return;
  window.__kidatagGlobalFix3108=true;
  const approved='https://cdn.shopify.com/s/files/1/1027/9619/8217/files/kidatag-collection-fermoir-valide.png?v=1788163880';
  const replaceWrongCollection=scope=>{
    (scope||document).querySelectorAll?.('img[src*="kidatag-nouvelle-gamme-collection.png"]').forEach(img=>{
      img.src=approved;
      img.removeAttribute('srcset');
      img.alt='KidaTag Licorne rose, Sirène lilas, Pirate beige et Dino vert avec le système de fermeture validé';
    });
  };
  replaceWrongCollection(document);
  const observer=new MutationObserver(records=>{
    for(const record of records){
      for(const node of record.addedNodes){
        if(node.nodeType===1){
          if(node.matches?.('img[src*="kidatag-nouvelle-gamme-collection.png"]')) replaceWrongCollection(node.parentElement||document);
          else replaceWrongCollection(node);
        }
      }
    }
  });
  observer.observe(document.documentElement,{childList:true,subtree:true});
})();
